"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const STEP_KEYS = ["create", "invite", "watch"] as const;

interface HowItWorksDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function HowItWorksDialog({ open, onOpenChange }: HowItWorksDialogProps) {
  const t = useTranslations("Home");
  const tSteps = useTranslations("Home.steps");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-2xl border border-(--mk-cream-08) bg-(--mk-ink-soft) text-(--mk-cream) shadow-[0_24px_64px_rgba(0,0,0,0.7)]">
        <DialogHeader>
          <DialogTitle className="font-serif text-xl text-(--mk-cream)">
            {t("howItWorksEyebrow")}
          </DialogTitle>
          <DialogDescription className="text-(--mk-cream-35)">
            {t("howItWorksBody")}
          </DialogDescription>
        </DialogHeader>
        <ol className="flex flex-col gap-4 py-1">
          {STEP_KEYS.map((key, index) => (
            <li key={key} className="flex gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-(--mk-gold) bg-(--mk-gold) font-serif text-sm font-bold text-(--mk-ink)">
                {index + 1}
              </span>
              <div>
                <p className="text-sm font-semibold text-(--mk-cream)">
                  {tSteps(`${key}.title`)}
                </p>
                <p className="mt-1 text-sm leading-relaxed text-(--mk-cream-35)">
                  {tSteps(`${key}.text`)}
                </p>
              </div>
            </li>
          ))}
        </ol>
        <Link
          href="/parties/create"
          onClick={() => onOpenChange(false)}
          className="flex w-full cursor-pointer items-center justify-center rounded-xl bg-(--mk-gold) px-4 py-3 text-sm font-semibold text-(--mk-ink) transition-colors hover:bg-(--mk-gold-light)"
        >
          {t("createAParty")}
        </Link>
      </DialogContent>
    </Dialog>
  );
}
